const HamburgerIcon = () => `<svg width="100%" height="100%" viewBox="0 0 24 25" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
  <line x1="21" y1="8.66943" x2="3" y2="8.66943" stroke="currentColor" stroke-width="2"/>
  <line x1="21" y1="17.627" x2="3" y2="17.627" stroke="currentColor" stroke-width="2"/>
  </svg>
  `;
export default HamburgerIcon;
